import { render, staticRenderFns } from "./VSidebar.vue?vue&type=template&id=34aaf617&scoped=true&"
import script from "./VSidebar.vue?vue&type=script&lang=js&"
export * from "./VSidebar.vue?vue&type=script&lang=js&"
import style0 from "./VSidebar.vue?vue&type=style&index=0&id=34aaf617&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aaf617",
  null
  
)

export default component.exports